import React, { useState } from "react";

const FSHomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Kako mogu prijaviti svoj turnir?",
      answer:
        "Prijavu turnira možeš izvršiti jednostavno klikom na gumb 'Pokrenite svoj turnir' ili slanjem poruke preko Instagrama na https://www.instagram.com/fucascore/ ",
    },
    {
      question: "Ažuriraju li se rezultati utakmica uživo?",
      answer:
        "Da! Rezultati i promjene rezultata ažuriraju se u stvarnom vremenu (Live) čim službeni zapisničar unese promjenu u sustav.",
    },
    {
      question: "Gdje mogu pratiti raspored utakmica i rezultate uživo?",
      answer:
        "Sve rasporede, tablice grupa i rezultate uživo možeš pratiti u stvarnom vremenu unutar sekcije za odabrani turnir na našoj platformi.",
    },
    {
      question: "Mogu li naknadno mijenjati popis igrača u svojoj ekipi?",
      answer:
        "Da, izmjene na popisu igrača obično su dozvoljene do početka prve utakmice ili službenog ždrijeba, ovisno o pravilima organizatora.",
    },
    {
      question:
        "Mogu li koristiti aplikaciju preko mobilnog uređaja bez instalacije?",
      answer:
        "Aplikacija je u potpunosti optimizirana za mobilne preglednike, tako da je možeš koristiti direktno putem weba bez obavezne instalacije.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="fshome-faq-section">
      <div className="scorify-section-header">
        <h3>Često postavljana pitanja (FAQ)</h3>
      </div>

      <div className="faq-stack">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className={`elite-faq-card ${isOpen ? "open" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="card-ambient-glow"></div>

              <div className="faq-question-row">
                <p className="faq-question-text">{faq.question}</p>
                <div className="faq-toggle-icon">
                  <i
                    className={`fi ${isOpen ? "fi-rs-angle-small-up" : "fi-rs-angle-small-down"}`}
                  ></i>
                </div>
              </div>

              {isOpen && (
                <div className="faq-answer-container">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FSHomeFAQ;
